module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "histogram-wrap clearfix"
  }, [_c('ul', {
    ref: "count-list",
    staticClass: "count-list"
  }, [_c('li', [_c('div', {
    staticClass: "content-part"
  }, [_c('div', {
    ref: "rightTop1",
    staticClass: "right-top"
  }, [_c('span', {
    ref: "rightDataTop",
    staticClass: "count"
  }, [_c('span', {
    staticClass: "product"
  }, [_vm._v(_vm._s(_vm.data[0].name))])]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.data[0].text))])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "content-part"
  }, [_c('div', {
    ref: "rightTop2",
    staticClass: "right-top"
  }, [_c('span', {
    ref: "rightDataTop",
    staticClass: "count"
  }, [_c('span', {
    staticClass: "product"
  }, [_vm._v(_vm._s(_vm.data[1].name))])]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.data[1].text))])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "content-part"
  }, [_c('div', {
    ref: "rightTop3",
    staticClass: "right-top"
  }, [_c('span', {
    ref: "rightDataTop",
    staticClass: "count"
  }, [_c('span', {
    staticClass: "product"
  }, [_vm._v(_vm._s(_vm.data[2].name))])]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.data[2].text))])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "content-part"
  }, [_c('div', {
    ref: "rightTop4",
    staticClass: "right-top"
  }, [_c('span', {
    ref: "rightDataTop",
    staticClass: "count"
  }, [_c('span', {
    staticClass: "product"
  }, [_vm._v(_vm._s(_vm.data[3].name))])]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.data[3].text))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-292486e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/number-v/index.vue
// module id = 229
// module chunks = 0